import React from "react";
import { Link } from "react-router-dom";
import "./SchoolLife.css";

const SchoolLife = ({ data, gallery }) => {
  const classroomGallery = gallery?.find(
    (item) => item.title === data?.life_activity?.title,
  );
  const latestImages = classroomGallery?.images?.slice(-3).reverse() || [];

  return (
    <section className="school-life">
      <p className="founder-subtitle">{data?.lifeSubTitle}</p>
      <h2 className="founder-title">{data?.life_activity?.title}</h2>

      <div className="school-life-grid">
        {latestImages.map((p) => (
          <img src={p?.url} alt="Sports Day Event 1" />
        ))}
      </div>

      <div className="gallery-btn">
        <Link to="/gallery">
          <button className="btn-outline">View Gallery</button>
        </Link>
      </div>
    </section>
  );
};

export default SchoolLife;
